const CNAPS_STUDENT = `cnaps-student/v1`;

export const endpoints = {
  LOGIN_STUDENT: `${CNAPS_STUDENT}/student/login`,
  SEND_OTP: `${CNAPS_STUDENT}/delete-account/send-otp`,
  VALIDATE_OTP: `${CNAPS_STUDENT}/delete-account/validate-otp`,
  REMOVE_ACCOUNT: `${CNAPS_STUDENT}/delete-account/remove-account`,
};
